import React from "react";
import Carousel from "./carousels";

export default function WhyCallSpeedoc() {
  return (
    <div id="whyCallSpeedoc">
      <div className="header">
        <h3>Why call Speedoc ?</h3>
      </div>
      <Carousel
        entries={[
          {
            uri: "https://public.speedoc.com/design/images/speedoc.com/carousel/images/slide1.jpg",
            uriSquare: "https://public.speedoc.com/design/images/speedoc.com/carousel/images/slide1-square.jpg",
            content: Slider1
          },
          {
            uri: "https://public.speedoc.com/design/images/speedoc.com/carousel/images/slide2.jpg",
            uriSquare: "https://public.speedoc.com/design/images/speedoc.com/carousel/images/slide2-square.jpg",
            content: Slider2
          },
          {
            uri: "https://public.speedoc.com/design/images/speedoc.com/carousel/images/slide3.jpg",
            uriSquare: "https://public.speedoc.com/design/images/speedoc.com/carousel/images/slide3-square.jpg",
            content: Slider3
          }
        ]}
      />
    </div>
  );
}

const Slider1 = () => {
  return (
    <>
      <h2>Respiratory symptoms:</h2>
      <p>
        For those with respiratory symptoms (cough, runny nose, or fever) and who are exercising good social
        responsibility to avoid public places:
      </p>
      <p>
        Speedoc can administer rapid influenza tests to check for influenza A & B that helps to rule out coronavirus
        disease.
      </p>
      <p>
        Based on MOH guidelines, Medical certificates (MC) of five days will be provided for patients with respiratory
        symptoms to stay home to recover.
      </p>
      <p> Those who do not recover within five days will be referred for further medical assessment and tests.</p>
      <p> Wear a mask and inform us (of your symptoms or travelling history) prior to our visit</p>
    </>
  );
};

const Slider2 = () => {
  return (
    <>
      <h2>For non-respiratory symptoms:</h2>
      <p>
        Speedoc's team of multilingual qualified doctors and trained nurses can provide medical assistance for common
        illnesses, geriatric care, palliative care, nursing care, ambulance booking, medicine delivery, post-operation
        and/or step down care.
      </p>
    </>
  );
};

const Slider3 = () => {
  return (
    <>
      <h2>Staying vigilant:</h2>
      <p>
        For all visits, our medical team is equipped with all protective equipment which includes masks, gowns and
        gloves.
      </p>
      <p>Being front-line healthcare professionals, we always know that there are risks involved.</p>
      <p>
        To us, it's part of the nature of the job and we are fully trained to take the necessary precautions and
        procedures for situations like this.
      </p>
    </>
  );
};
